module.exports = __webpack_public_path__ + "static/media/tick.a15e5387.svg";